import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import EnterLastName from './index';
import { colors } from '../../constants/colors';
import { isEmptyObject } from '../../core/util/object';

const SmoothDialog = styled(Dialog).withConfig({ componentId: 'sc-gwyv0l-0' })`
  -webkit-font-smoothing: antialiased;
  & .dialog-root {
    background-color: ${colors.whiteGrey};
  }
`;

const Close = styled.div.withConfig({ componentId: 'sc-gwyv0l-1' })`
  width: 25px;
  height: 25px;
  position: absolute;
  right: 26px;
  top: 20px;
  cursor: pointer;

  &:before {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(45deg);
    background-color: ${colors.theWhiteAlbum};
  }

  &:after {
    content: '';
    left: 50%;
    height: 100%;
    width: 1px;
    position: absolute;
    transform: rotate(-45deg);
    background-color: ${colors.theWhiteAlbum};
  }
`;

type Props = {
  open?: boolean;
  fullScreen?: boolean;
  onClose?: (...args: any[]) => any;
  onSkip?: (...args: any[]) => any;
  onVerifySuccess?: (...args: any[]) => any;
  profileToVerify?: any;
};

class EnterLastNameModal extends PureComponent<Props> {
  render() {
    const { open, fullScreen, onClose, onSkip, onVerifySuccess, profileToVerify } = this.props;

    if (isEmptyObject(profileToVerify) || profileToVerify.is_verified) return null;

    return (
      <SmoothDialog
        fullScreen={fullScreen}
        fullWidth
        maxWidth="sm"
        onClose={onClose}
        // @ts-expect-error ts-migrate(2769) FIXME: Type 'undefined' is not assignable to type 'boolea... Remove this comment to see the full error message
        open={open}
        PaperProps={{ classes: { root: 'dialog-root' } }}
        scroll="body"
      >
        <Close onClick={onClose} />

        <EnterLastName
          // @ts-expect-error ts-migrate(2322) FIXME: Property 'onSkip' does not exist on type '(Intrins... Remove this comment to see the full error message
          onSkip={onSkip}
          onVerifySuccess={onVerifySuccess}
          profileToVerify={profileToVerify}
        />
      </SmoothDialog>
    );
  }
}

export default withMobileDialog({ breakpoint: 'xs' })(EnterLastNameModal);
